import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Navigation from './components/Navigation';
import Hero from './components/Hero';
import About from './components/About';
import Services from './components/Services';
import Clients from './components/Clients';
import Projects from './components/Projects';
import Tools from './components/Tools';
import Testimonials from './components/Testimonials';
import Contact from './components/Contact';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import { Toaster } from './components/ui/sonner';

// Tools Pages
import ToolsHub from './pages/tools/ToolsHub';
import Auth from './pages/tools/Auth';
import EmailGenerator from './pages/tools/EmailGenerator';
import BriefGenerator from './pages/tools/BriefGenerator';
import CompetitorAnalysis from './pages/tools/CompetitorAnalysis';

// Policy Pages
import CancellationPolicy from './pages/policies/CancellationPolicy';
import TermsAndConditions from './pages/policies/TermsAndConditions';
import DeliveryPolicy from './pages/policies/DeliveryPolicy';
import PrivacyPolicy from './pages/policies/PrivacyPolicy';
import ContactUs from './pages/policies/ContactUs';

// Account Settings
import AccountSettings from './pages/AccountSettings';

// Main Home Page Component
const HomePage = () => {
  return (
    <>
      <Navigation />
      <Hero />
      <About />
      <Services />
      <Projects />
      <Tools />
      <Testimonials />
      <Contact />
      <Footer />
    </>
  );
};

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <div className="App">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/tools" element={<ToolsHub />} />
          <Route path="/tools/auth" element={<Auth />} />
          <Route path="/tools/email" element={<EmailGenerator />} />
          <Route path="/tools/brief" element={<BriefGenerator />} />
          <Route path="/tools/competitor" element={<CompetitorAnalysis />} />
          
          {/* Policy Pages */}
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
          <Route path="/cancellation-policy" element={<CancellationPolicy />} />
          <Route path="/delivery-policy" element={<DeliveryPolicy />} />
          <Route path="/contact-us" element={<ContactUs />} />
          
          {/* Account Settings */}
          <Route path="/account-settings" element={<AccountSettings />} />
        </Routes>
        <Toaster />
      </div>
    </BrowserRouter>
  );
}

export default App;
